import { render, staticRenderFns } from "./OwnerDriverList.vue?vue&type=template&id=10b1351a&scoped=true&lang=html&"
import script from "./OwnerDriverList.vue?vue&type=script&lang=js&"
export * from "./OwnerDriverList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b1351a",
  null
  
)

export default component.exports